import SiteIcon from '@mui/icons-material/Web';

import SetupAccordionCreate from './SetupCreate';

export default {
  create: SetupAccordionCreate,
  ICON: SiteIcon
};